<script lang="ts" setup>
import Menu from 'primevue/menu'
import type { MenuItem } from 'primevue/menuitem'

const menu = ref<typeof Menu>()
const props = defineProps<{
  options?: MenuItem[]
}>()

const firstOption = computed<MenuItem | null>(
  () => props.options?.shift() ?? null
)

const hasBack = computed<boolean>(() => {
  if (!import.meta.client) return false
  return window.history.length > 1
})

// @ts-ignore
const toggleMenu = (event: MouseEvent) => menu?.value.toggle(event)

const router = useRouter()
</script>

<template>
  <div class="flex gap-5 items-center">
    <ClientOnly>
      <Button
        v-if="hasBack"
        icon="pi pi-arrow-left"
        link
        rounded
        @click="router.back()"
      />
    </ClientOnly>

    <h2
      class="flex-grow font-semibold my-4 text-3xl text-surface-800 dark:text-surface-0"
      itemprop="name"
    >
      <slot />
    </h2>

    <div v-if="options && options.length > 1">
      <Button
        aria-label="Page actions"
        icon="pi pi-plus"
        rounded
        @click="toggleMenu"
      />
      <Menu :model="props.options" :popup="true" ref="menu" />
    </div>
    <div v-else-if="options && firstOption">
      <Button
        :icon="firstOption.icon"
        rounded
        @click="
          (event: MouseEvent) => {
            if (firstOption?.command)
              firstOption.command({ originalEvent: event, item: firstOption })
          }
        "
      />
    </div>
  </div>
</template>
